console.log('js/components/customer/reset-password.js -> v0.1.0');

(() => {
	const accountPasswordNew = document.querySelector('#account_password_new');

	if (accountPasswordNew) {
		accountPasswordNew.addEventListener('focusout', function (event) {
			validation.isPasswordValid(event.target, '.password-validation');
		});
	}

	document.addEventListener('keyup', function(event) {
		if (event.target.id == 'account_password_new') {
			if (event.target.value.length > 2) {
				passwordValidation(event.target);
			}
		}
	});

	document.addEventListener('click', function(event) {
		if (event.target.classList.contains('toggle-password-visibility')) {
			var formElement = validation.findAncestor(event.target, '.has-password-visibility-switcher');
			var input = formElement.querySelector('.form-control');

			if (input.type == "password") {
				input.type = "text";
				event.target.classList.add('is-visible');
			}
			else {
				input.type = "password";
				event.target.classList.remove('is-visible');
			}
		}
	});

	const form = document.querySelector('#plt-reset-password');

	// check if the form exists on the page
	if (form !== null) {
		// validation elements for password
		var minimalPasswordLength = 8;
		var checkLengthElement = form.querySelector('.password-validation .check-length');
		var checkNumberElement = form.querySelector('.password-validation .check-number');
		var checkUppercaseElement = form.querySelector('.password-validation .check-uppercase');
		var checkLowercaseElement = form.querySelector('.password-validation .check-lowercase');

		form.addEventListener('submit', function(event) {
			event.preventDefault();

			const form = this;
			const submitButton = this.querySelector('#reset-password-form-submit');
			const errorBlock = this.querySelector('.js-error');
			const successBlock = this.querySelector('.js-success');
			const passwordField = form.querySelector('#account_password_new');
			const confirmPasswordField = form.querySelector('#account_password_new_repeat');

			const csrfToken = document.querySelector('#csrfToken').value;

			// set loading state on the submit button
			submitButton.classList.add('is-loading');

			if (validation.containsSameValue(passwordField.value, confirmPasswordField.value) == false) {
				errorBlock.classList.add('active');
				errorBlock.innerHTML = "Passwords do not match";

				// set loading state on the submit button
				submitButton.classList.remove('is-loading');

				return false;
			}

			const request = {
				"reset-password-token": document.querySelector('#reset-password-token').value,
				"password": passwordField.value,
				"confirm-password": confirmPasswordField.value
			}

			const params = {
				credentials: 'same-origin',
				method: 'POST',
				body: JSON.stringify(request),
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'X-CSRF-Token': csrfToken
				}
			}

			gae('customer','reset_password_submit');

			fetch("/account/auth/reset-password", params)
			.then(function(response) {
				return response.json();
			})
			.then(function(response) {
				if (response.status == "ok") {
					gae('customer','reset_password_submit_ok');
					setTimeout(function() {
						successBlock.style.display = 'block';
						window.location.replace('/');
					}, 3000);
				}

				if (response.status == "error") {
					submitButton.classList.remove('is-loading');
					errorBlock.classList.add('active');
					errorBlock.innerHTML = response.error;
					gae('customer','reset_password_submit_error');
				}

			})
			.catch(function(error) {
				console.error('Error:', error);
			});
		});
	}

	function passwordValidation(element) {
		let value = element.value;

		validation.setValidation(checkLengthElement, validation.isMinimalLength(value, minimalPasswordLength));
		validation.setValidation(checkNumberElement, validation.containsNumbers(value));
		validation.setValidation(checkUppercaseElement, validation.containsUppercaseCharacters(value));
		validation.setValidation(checkLowercaseElement, validation.containsLowercaseCharacters(value));
	}

})();
